import { Badge } from '@cloudscape-design/components';
import type { TenantStatus } from '../types/tenant';

const STATUS_COLOR: Record<TenantStatus, 'green' | 'blue' | 'red' | 'grey'> = {
  active: 'green',
  provisioning: 'blue',
  suspended: 'red',
  deprovisioning: 'red',
  deprovisioned: 'grey',
  archived: 'grey',
};

const STATUS_LABEL: Record<TenantStatus, string> = {
  active: 'Active',
  provisioning: 'Provisioning',
  suspended: 'Suspended',
  deprovisioning: 'Deprovisioning',
  deprovisioned: 'Deprovisioned',
  archived: 'Archived',
};

interface StatusBadgeProps {
  status: TenantStatus;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  return <Badge color={STATUS_COLOR[status] ?? 'grey'}>{STATUS_LABEL[status] ?? status}</Badge>;
}
